import type { ProductPageQuery } from '#shared/apollo-api';
import type { TProductCharacteristicType, IPdp } from '~/entities';

export function gqlPdpProductMapper(gqlPdpProduct: ProductPageQuery['product']): IPdp {
  return {
    title: gqlPdpProduct.title,
    minFullPrice: gqlPdpProduct.minFullPrice,
    minSellPrice: gqlPdpProduct.minSellPrice,
    characteristics: gqlPdpProduct.characteristics.map((char) => ({
      title: char.title,
      type: char.type,
      id: char.id,
      values: char.values.map((it) => ({
        value: it.value,
        title: it.title,
        id: it.id,
        photo: it.photo?.link?.low,
      })),
    })),
    nearestDelivery: gqlPdpProduct.cardNearestDeliveryInfo?.nearestDelivery,
    badges: gqlPdpProduct.badges,
    skuList: gqlPdpProduct.skuList.map((sku) => ({
      skuId: sku.id.toString(),
      availableAmount: sku.availableAmount,
      sellPrice: sku.sellPrice,
      fullPrice: sku.fullPrice,
      title: sku.skuTitle,
      photo: { key: sku.photo.key },
      characteristicValues: sku.characteristicValues.map((it) => ({
        id: it.id,
        label: it.title,
        value: it.value,
        characteristicId: it.characteristic.id,
        characteristicTitle: it.characteristic.title,
        characteristicType: it.characteristic.type as TProductCharacteristicType,
      })),
    })),
    photos: gqlPdpProduct.photos.map((it) => ({
      // @ts-ignore
      low: it.thumbnail?.low,
      high: it.link?.high,
      key: it.key,
    })),
  };
}
